import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  INoticeCreateReq,
  INoticeEditReq,
  INoticeDetailRes,
  INoticePageReq,
  INoticePageRes,
  IbatchDictValuesRes,
} from './type.d';
/**
 * 创建通知
 */
export const noticeCreate = (params: INoticeCreateReq) => {
  const url = '/cms-service/web/v1/notice/create';
  return http.post({
    url,
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 编辑通知
 */
export const noticeEdit = (params: INoticeEditReq) => {
  const url = '/cms-service/web/v1/notice/edit';
  return http.post({
    url,
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 通知详情
 */
export const getnoticeInfo = (noticeCode: string) => {
  const url = `/cms-service/web/v1/notice/detail/${noticeCode}`;
  return http.get<INoticeDetailRes>({
    url,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 通知分页
 */
export const noticePage = (params: INoticePageReq) => {
  const url = '/cms-service/web/v1/notice/page';
  return http.post<INoticePageRes>({
    url,
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 通知撤回
 */
export const noticeWithdraw = (noticeCode: string) => {
  const url = `/cms-service/web/v1/notice/withdraw/${noticeCode}`;
  return http.get({
    url,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 通过通知code进行开始更新
 */
export const noticeStartUpdate = (noticeCode: string) => {
  const url = `/cms-service/web/v1/notice/startUpdate/${noticeCode}`;
  return http.get({
    url,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 通过通知code结束更新
 */
export const noticeFinishUpdate = (noticeCode: string) => {
  const url = `/cms-service/web/v1/notice/finishUpdate/${noticeCode}`;
  return http.get({
    url,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 字典值 - 批量
export const getSystemDictValues = (data: string[]) => {
  const url = '/ufg/web/v1/dict-value/batch-list';
  return http.post<IbatchDictValuesRes[]>({
    url,
    data: { dictCodes: data },
    loading: false,
    isNotCancel: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
